(function () {
  var MARKET_PREFERENCE_KEY = 'hc_market_preference_v1';
  var MARKET_DETECTED_KEY = 'hc_market_detected_v1';
  var MARKET_CHOICE_PARAM = 'hc_market_choice';
  var MARKET_PREFERENCE_TTL = 90 * 24 * 60 * 60 * 1000;
  var MARKET_HOSTS = {
    EG: 'humanitycode.shop',
    AE: 'uae.humanitycode.store',
    SA: 'ksa.humanitycode.store',
    KW: 'kuwait.humanitycode.store',
    US: 'worldwide.humanitycode.store'
  };

  function normalizeMarketCode(code) {
    return MARKET_HOSTS[code] ? code : 'US';
  }

  function marketCodeForLocation(countryCode) {
    if (countryCode === 'EG') return 'EG';
    if (countryCode === 'AE') return 'AE';
    if (countryCode === 'SA') return 'SA';
    if (countryCode === 'KW') return 'KW';
    return 'US';
  }

  function rememberMarketPreference(code) {
    var normalizedCode = normalizeMarketCode(code);

    try {
      var cookieDomain =
        window.location.hostname === 'humanitycode.shop'
          ? 'humanitycode.shop'
          : 'humanitycode.store';
      document.cookie =
        MARKET_PREFERENCE_KEY +
        '=' +
        normalizedCode +
        '; Max-Age=' +
        MARKET_PREFERENCE_TTL / 1000 +
        '; Path=/; Domain=' +
        cookieDomain +
        '; SameSite=Lax; Secure';
    } catch (error) {
      // The local preference below remains available if cookies are blocked.
    }

    try {
      window.localStorage.setItem(
        MARKET_PREFERENCE_KEY,
        JSON.stringify({
          code: normalizedCode,
          expiresAt: Date.now() + MARKET_PREFERENCE_TTL
        })
      );
    } catch (error) {
      // Storage can be unavailable in strict privacy modes; routing still works.
    }
  }

  function readMarketPreference() {
    try {
      var cookie = (document.cookie || '')
        .split('; ')
        .find(function (value) {
          return value.indexOf(MARKET_PREFERENCE_KEY + '=') === 0;
        });
      var cookieCode = cookie ? cookie.split('=')[1] : null;
      if (MARKET_HOSTS[cookieCode]) return cookieCode;
    } catch (error) {
      // Fall through to local storage.
    }

    try {
      var value = JSON.parse(window.localStorage.getItem(MARKET_PREFERENCE_KEY));

      if (!value || !MARKET_HOSTS[value.code] || value.expiresAt <= Date.now()) {
        window.localStorage.removeItem(MARKET_PREFERENCE_KEY);
        return null;
      }

      return value.code;
    } catch (error) {
      return null;
    }
  }

  function rememberDetectedMarket(code) {
    try {
      window.sessionStorage.setItem(MARKET_DETECTED_KEY, normalizeMarketCode(code));
    } catch (error) {
      // Session storage is an optimization only.
    }
  }

  function readDetectedMarket() {
    try {
      var code = window.sessionStorage.getItem(MARKET_DETECTED_KEY);
      return MARKET_HOSTS[code] ? code : null;
    } catch (error) {
      return null;
    }
  }

  function consumeMarketChoice() {
    var url = new URL(window.location.href);
    var code = url.searchParams.get(MARKET_CHOICE_PARAM);

    if (!code || !MARKET_HOSTS[code]) return null;

    rememberMarketPreference(code);
    url.searchParams.delete(MARKET_CHOICE_PARAM);
    window.history.replaceState(null, '', url.pathname + url.search + url.hash);
    return code;
  }

  function routeToMarket(code) {
    var targetHost = MARKET_HOSTS[normalizeMarketCode(code)];

    if (!targetHost || window.location.hostname === targetHost) return;

    var targetUrl = new URL(window.location.href);
    targetUrl.protocol = 'https:';
    targetUrl.hostname = targetHost;
    targetUrl.port = '';
    targetUrl.searchParams.delete(MARKET_CHOICE_PARAM);
    window.location.replace(targetUrl.toString());
  }

  function shouldSkipAutomaticRouting() {
    var knownHost =
      window.location.hostname === 'humanitycode.store' ||
      Object.keys(MARKET_HOSTS).some(function (code) {
      return MARKET_HOSTS[code] === window.location.hostname;
      });
    var protectedPath = /^\/(?:admin|account|cart|checkouts?|customer_authentication|localization|password)(?:\/|$)/.test(
      window.location.pathname
    );
    var crawler = /bot|crawl|spider|slurp|facebookexternalhit|bingpreview/i.test(
      window.navigator.userAgent
    );

    return !knownHost || protectedPath || crawler || window.Shopify && window.Shopify.designMode;
  }

  function initializeAutomaticMarketRouting() {
    if (shouldSkipAutomaticRouting()) return;

    var explicitChoice = consumeMarketChoice();
    if (explicitChoice) {
      routeToMarket(explicitChoice);
      return;
    }

    var preference = readMarketPreference();
    if (preference) {
      routeToMarket(preference);
      return;
    }

    var detectedMarket = readDetectedMarket();
    if (detectedMarket) {
      routeToMarket(detectedMarket);
      return;
    }

    window
      .fetch('/cdn-cgi/trace', {
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { Accept: 'text/plain' }
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Location lookup unavailable');
        return response.text();
      })
      .then(function (trace) {
        var match = trace.match(/(?:^|\n)loc=([A-Z]{2})(?:\n|$)/);
        if (!match) return;

        var marketCode = marketCodeForLocation(match[1]);
        rememberDetectedMarket(marketCode);
        routeToMarket(marketCode);
      })
      .catch(function () {
        // Fail open: shoppers can still use the visible country selector.
      });
  }

  function appendHiddenField(form, name, value) {
    var field = document.createElement('input');
    field.type = 'hidden';
    field.name = name;
    field.value = value;
    form.appendChild(field);
  }

  function submitMarketChoice(choice) {
    var action = choice.getAttribute('formaction');
    var countryCode = choice.value;

    if (!action || !countryCode) return;

    document.documentElement.classList.add('hc-market-switching');
    choice.setAttribute('aria-busy', 'true');
    rememberMarketPreference(countryCode);

    var returnTo = new URL(window.location.href);
    returnTo.searchParams.set(MARKET_CHOICE_PARAM, normalizeMarketCode(countryCode));

    var localizationForm = document.createElement('form');
    localizationForm.method = 'post';
    localizationForm.action = action;
    localizationForm.acceptCharset = 'UTF-8';
    localizationForm.enctype = 'multipart/form-data';
    localizationForm.hidden = true;

    appendHiddenField(localizationForm, 'form_type', 'localization');
    appendHiddenField(localizationForm, 'utf8', '✓');
    appendHiddenField(localizationForm, '_method', 'put');
    appendHiddenField(
      localizationForm,
      'return_to',
      returnTo.pathname + returnTo.search + returnTo.hash
    );
    appendHiddenField(localizationForm, 'country_code', countryCode);

    document.body.appendChild(localizationForm);
    localizationForm.submit();
  }

  document.addEventListener('click', function (event) {
    var choice = event.target.closest('[data-hc-market-choice]');

    if (choice) {
      event.preventDefault();
      event.stopPropagation();
      submitMarketChoice(choice);
      return;
    }

    document.querySelectorAll('[data-hc-market-menu][open]').forEach(function (menu) {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    });
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-hc-market-menu][open]').forEach(function (menu) {
      menu.removeAttribute('open');
    });
  });

  initializeAutomaticMarketRouting();
})();

(function () {
  const selector = '[data-testid="klaviyo-form-RNbMMW"], .kl-teaser-RNbMMW';
  let retry;
  function dismissWelcomeOffer(attempt = 0) {
    clearTimeout(retry);
    document.querySelectorAll(selector).forEach(element => {
      const container = element.closest('[role="dialog"]') || element;
      const close = container.querySelector('.klaviyo-close-form');
      if (close) close.click();
    });
    if (attempt < 12 && document.querySelector(selector)) {
      retry = setTimeout(() => dismissWelcomeOffer(attempt + 1), 250);
    }
  }
  const observer = new MutationObserver(records => {
    if (records.some(record =>
      (record.type === 'attributes' &&
        (record.target === document.body || record.target.matches('[role="dialog"], .kl-teaser-RNbMMW'))) ||
      Array.from(record.addedNodes).some(node =>
        node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
      )
    )) dismissWelcomeOffer();
  });
  observer.observe(document.body, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['class', 'style', 'aria-hidden']
  });
  dismissWelcomeOffer();
  window.addEventListener('pagehide', () => clearTimeout(retry));
})();
